export const formatAssetLabel = (asset, chain) => {
  if (!asset) return "-";
  const token = asset["asset-token"];
  return chain?.["chain-name"] ? `${token} (${chain["chain-name"]})` : token;
};

export const findAssetIdsBySymbol = (symbol, assets) => {
  if (!symbol || !assets) return [];
  return assets.filter((a) => a["asset-token"] === symbol).map((a) => a.id);
};

export const buildSymbolDropdownOptions = (assets, chainsMap) => {
  if (!assets) return [];

  const perChainOptions = assets.map((a) => ({
    label: formatAssetLabel(a, chainsMap?.get(a["chain-id"])),
    value: a.id,
  }));

  // Group by symbol so we can identify which symbols span multiple chains.
  const bySymbol = new Map();
  for (const a of assets) {
    const sym = a["asset-token"];
    if (!bySymbol.has(sym)) bySymbol.set(sym, []);
    bySymbol.get(sym).push(a);
  }

  const syntheticOptions = [];
  for (const [sym, group] of bySymbol) {
    if (group.length >= 2) {
      syntheticOptions.push({ label: `${sym} (all chains)`, value: `symbol:${sym}` });
    }
  }

  return [...perChainOptions, ...syntheticOptions].sort((x, y) => x.label.localeCompare(y.label));
};
